import { render, staticRenderFns } from "./TehtavatHallitus.vue?vue&type=template&id=0f5b0d84"
import script from "./TehtavatHallitus.vue?vue&type=script&lang=js"
export * from "./TehtavatHallitus.vue?vue&type=script&lang=js"
import style0 from "./TehtavatHallitus.vue?vue&type=style&index=0&id=0f5b0d84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports